import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  for: "email",
  class: "form-label"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "form-error-text" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = {
  for: "password",
  class: "form-label"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-error-text" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "ml-2 text-sm mb-1" }
const _hoisted_12 = { class: "pt-4 pb-2 flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('word.email')), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        id: "email",
        name: "email",
        type: "email",
        placeholder: _ctx.t('word.email'),
        class: _normalizeClass(`form-input mb-1 ${_ctx.errors['email'] ? 'border-red-500' : ''}`)
      }, null, 10, _hoisted_3), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errors['email']), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t('word.password')), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        id: "password",
        name: "password",
        type: "password",
        placeholder: _ctx.t('word.password'),
        class: _normalizeClass(`form-input mb-1 ${_ctx.errors['password'] ? 'border-red-500' : ''}`)
      }, null, 10, _hoisted_7), [
        [_vModelText, _ctx.password]
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors['password']), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.remember]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('login.save_login_status')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_base_form_submit, {
        disabled: _ctx.btnDisabled,
        text: _ctx.t('word.login')
      }, null, 8, ["disabled", "text"]),
      _createVNode(_component_router_link, {
        to: "/forgot-password",
        class: "text-link text-sm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('forgot_password.title')), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}